import React, { useState } from "react";
import { getPhotoUrl } from "../services/apiConfig";

const AVATAR_GRADIENTS = [
	"linear-gradient(135deg, #30a49a, #2a8f87)",
	"linear-gradient(135deg, #F87B1B, #d4600e)",
	"linear-gradient(135deg, #6C5CE7, #A29BFE)",
	"linear-gradient(135deg, #e17055, #c75e44)",
	"linear-gradient(135deg, #00b894, #009e7c)",
	"linear-gradient(135deg, #fd79a8, #e84393)",
	"linear-gradient(135deg, #0984e3, #0764b8)",
	"linear-gradient(135deg, #55efc4, #00b894)",
];

function getAvatarGradient(seed) {
	let hash = 0;
	const s = String(seed || "");
	for (let i = 0; i < s.length; i++) {
		hash = s.charCodeAt(i) + ((hash << 5) - hash);
	}
	return AVATAR_GRADIENTS[Math.abs(hash) % AVATAR_GRADIENTS.length];
}

function getInitials(prenom, nom) {
	const a = (prenom || "?").charAt(0);
	const b = (nom || "?").charAt(0);
	return (a + b).toUpperCase();
}

export default function Avatar({ prenom, nom, photo, size = 40, className = "", style = {} }) {
	const [photoFailed, setPhotoFailed] = useState(false);
	const initials = getInitials(prenom, nom);
	const gradient = getAvatarGradient((prenom || "") + (nom || ""));
	const photoUrl = photo && !photoFailed ? getPhotoUrl(photo) : null;

	return (
		<div
			className={`gn-avatar ${className}`}
			style={{
				width: size,
				height: size,
				borderRadius: "50%",
				background: gradient,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				fontFamily: "var(--font-heading)",
				fontWeight: 600,
				fontSize: Math.max(10, Math.round(size * 0.36)),
				color: "#fff",
				flexShrink: 0,
				letterSpacing: "0.3px",
				overflow: "hidden",
				position: "relative",
				...style,
			}}
		>
			{photoUrl ? (
				<img
					src={photoUrl}
					alt=""
					onError={() => setPhotoFailed(true)}
					style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
				/>
			) : (
				initials
			)}
		</div>
	);
}
